// A figure/table block's `caption` → the plain text it stands for.
//
// The caption is edited and displayed as plain text, but it is stored as
// sanitised HTML: the SanitizedHtmlJson cast runs it through
// App\Support\HtmlSanitizer on write and read, and ai-service escapes it
// before that so a "<" can't swallow the text after it. So "A & B" is
// stored as "A &amp; B" — shown as-is it read "&amp;" on the page and in
// the editor. Decode it once here, then let the caller escape for display.
//
// Pure string work (no DOM), so it runs the same under SSR.

const NAMED = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };

export function captionText(value) {
    if (!value) return '';
    return String(value)
        .replace(/<[^>]*>/g, '')
        .replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, code) => {
            if (code[0] === '#') {
                const point = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
                return Number.isFinite(point) && point > 0 && point <= 0x10ffff ? String.fromCodePoint(point) : entity;
            }
            return NAMED[code.toLowerCase()] ?? entity;
        });
}
